module.exports = __webpack_public_path__ + "img/music.b782c0d5.svg";